import { render, staticRenderFns } from "./wechatDialog.vue?vue&type=template&id=184738c9&"
import script from "./wechatDialog.vue?vue&type=script&lang=js&"
export * from "./wechatDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports